import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetGradeInfoById, IGetGradeLevelInfoResponse } from '@/Module/Grade/Model/ApiModel';
import GradeService from '@/Module/Grade/Service/GradeService';

export const getGradeInfoByIdAction = createAsyncThunk<IGetGradeLevelInfoResponse, IGetGradeInfoById>(
  'level/getGradeDataAction',
  async ({ gradeId, Includes }, { signal }) => {
    return GradeService.getGradeInfoById(gradeId, Includes, signal).then(
      ({
        data: {
          data: { data },
        },
      }) => data,
    );
  },
);
